import React, { useReducer } from 'react'
import { reducer, State, Action } from './reducers'

interface StoreValue {
  state: State
  dispatch: React.Dispatch<Action>
}

export const Store = React.createContext<StoreValue>({
  state: {
    clinicId: undefined,
    clinicName: undefined,
    clinicPhoneNumber: undefined,
    service: undefined,
    urlToken: undefined
  },
  dispatch: () => {}
})

export const Provider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const initialState: State = {
    clinicId: localStorage.getItem('clinicId') || undefined,
    clinicName: localStorage.getItem('clinicName') || undefined,
    clinicPhoneNumber: localStorage.getItem('clinicPhoneNumber') || undefined,
    service: sessionStorage.getItem('service') as string || undefined,
    urlToken: sessionStorage.getItem('urlToken') as string || undefined 
  }

  const [state, dispatch] = useReducer(reducer, initialState)
  const store = { state, dispatch }

  return <Store.Provider value={store}>{children}</Store.Provider>
}
